<template>
  <a class="sr-only focus:not-sr-only transition-transform -translate-y-10 focus:translate-y-0 focus:fixed focus:left-4 focus:top-4 focus:bg-white focus:py-2 focus:px-4 focus:shadow-lg focus:rounded-full focus:outline-none focus:text-black focus:ring-2 ring-black focus:z-90" href="#main-content">Hyppää pääsisältöön</a>
</template>
